import {
  type AB_VARIANT_KEY_COLUMNS,
  BODY_VARIANT_KEY_COLUMN,
  SUBJECT_VARIANT_KEY_COLUMN,
} from "./columns";

/**
 * How long an A/B test keeps collecting metrics after its active phase ends —
 * whether a winner is promoted by hand (frontend "Promote a winner") or the
 * campaign finishes sending (backend auto-end in `end-message-experiments.ts`).
 * Both stamp `experiments.completed_at` this far out. Shared so the two paths
 * can't silently drift to different windows.
 */
export const AB_TEST_MEASUREMENT_WINDOW_DAYS = 30;

/** Tested message element — matches `message_experiments.element`. */
export type MessageAbTestElement = "subject_preheader" | "body";

export type MessageAbTestArm = {
  variantKey: string;
  percentage: number;
};

export type MessageAbTest = {
  element: MessageAbTestElement;
  arms: MessageAbTestArm[];
};

export function isMessageAbTestElement(
  value: string,
): value is MessageAbTestElement {
  return value === "subject_preheader" || value === "body";
}

/** Map `message_experiments.element` → warehouse assignment column. */
export function variantKeyColumnForElement(
  element: MessageAbTestElement,
): (typeof AB_VARIANT_KEY_COLUMNS)[number] {
  return element === "subject_preheader"
    ? SUBJECT_VARIANT_KEY_COLUMN
    : BODY_VARIANT_KEY_COLUMN;
}
